import React, { Component, Fragment } from 'react'
import ReactPixel from 'react-facebook-pixel'
import { withRouter } from 'react-router-dom'
import { config } from '../../config.js'
import {
  Grid,
  Paper,
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { startCase } from 'lodash'
import AppTopBar from '../../components/AppTopBar'
import GroupsBar from '../../components/GroupsBar'
import DestinationList from '../../components/lists/DestinationList'
import SearchPanel from '../../components/SearchPanel'
import InfiniteScroll from 'react-infinite-scroll-component'
import Cookies from 'universal-cookie'
import { CUISINES, THINGS_TO_DO } from '../../utils/lists'

const cookies = new Cookies();
const API = config.api.TRAVEL_URL
let abortController = new AbortController()

class UserHome extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isLoading: false,
      destination_groups: [],
      filters: {},
      page: 0,
      hasMore: true,

      filters: {
        saved: [],
      },
      search_params: {
        travelers: {
          adults: 1,
          children: 0,
          infants: 0,
        },
        dates: {
          dates_type: 'cheapest',
          start_date: null,
          end_date: null,
          nights: [2, 10],
        },
        from: null,
        to: null,
      },
    }
  }

  componentDidMount() {
    this.getDestinations()
    ReactPixel.pageView()
  }

  handleReloadResults = () => {
    this.setState({
      destination_groups: [],
      isLoading: true,
    }, this.getDestinations)
  }

  handleFiltersChange = (event) => {
    // console.log({ filters: {...this.state.filters, ...event.target.value} })
    this.setState({
      filters: {...this.state.filters, ...event.target.value},
      page: 0,
      destination_groups: [],
    }, this.getDestinations);
  }

  handleSearch = (search_params = {}) => {
    let { dates, ...rest } = search_params
    let dates_params = {}

    if (Object.keys(dates).length > 0) {
      dates_params = Object.entries(dates).reduce((a,[k,v]) => (v === null ? a : (a[k]=v, a)), {})
    }

    if (Object.keys(dates_params).length > 0) {
      dates_params = {dates: dates_params}
    }

    search_params = {...rest, ...dates_params}

    this.setState({
      search_params: {...this.state.search_params, ...search_params},
      page: 0,
      destination_groups: [],
    }, this.getDestinations)
  }

  getDestinations = () => {
    let travel_preference = (this.props.user ? this.props.user.travel_preference : null)
    let { filters, search_params } = this.state
    let { dates, travelers } = search_params
    let location_from = (search_params && search_params.from ? search_params.from[0] : null)

    this.setState({isLoading: true})

    abortController.abort()
    abortController = new AbortController();
    const signal = abortController.signal

    fetch(API + '/destinations/recommendations/feed' +
                '?page=' + (this.state.page + 1) +

                (travelers && travelers.adults ? '&adults=' + travelers.adults : '') +
                (travelers && travelers.children ? '&children=' + travelers.children : '') +
                (travelers && travelers.infants ? '&infants=' + travelers.infants : '') +

                (dates && dates.dates_type ? '&dates_type=' + dates.dates_type : '') +
                (dates && dates.start_date ? '&start_date=' + dates.start_date : '') +
                (dates && dates.end_date ? '&end_date=' + dates.end_date : '') +
                (dates && dates.nights ? '&nights=' + dates.nights : '') +

                (location_from && location_from.slug ? '&location_from=' + location_from.slug : '') +
                (location_from && location_from.latitude ? '&latitude_from=' + location_from.latitude : '') +
                (location_from && location_from.longitude ? '&longitude_from=' + location_from.longitude : '') +

                (filters && filters.budget !== undefined ? '&budget=' + filters.budget : '') +
                (filters && filters.weather !== undefined ? '&weather=' + filters.weather.join(',') : '') +
                (filters && filters.things_to_do !== undefined && !filters.things_to_do.includes('all') ? '&things_to_do=' + filters.things_to_do : '') +
                (filters && filters.saved !== undefined && filters.saved.length > 0 ? '&saved=' + filters.saved.join(',') : '')
                ,
      {
        headers: {
          'Authorization': `Bearer ${cookies.get('jwt')}`
        },
        signal: signal,
      })
      .then(response => response.json())
      .then(data => {
        let group = data.destination_groups[0]

        if (group) {
          this.setState(prevState => ({
            isLoading: false,
            destination_groups: prevState.page === 0 ? data.destination_groups : [...prevState.destination_groups, ...data.destination_groups],
            hasMore: group.has_next_page,
            page: prevState.page + 1,
          }))
        }
      })
  }

  foodItem = (name) => {
    return CUISINES.filter((cuisine) => cuisine.value === name)[0]
  }

  activityItem = (name) => {
    return THINGS_TO_DO.filter((activity) => activity.value === name)[0]
  }

  render() {
    const { classes, user } = this.props
    const vibe_score_pair_1 = user.travel_preference && -(user.travel_preference.vibe_adventurous - user.travel_preference.vibe_romantic)
    const vibe_score_pair_2 = user.travel_preference && -(user.travel_preference.vibe_chill_relaxing - user.travel_preference.vibe_fast_paced)
    const vibe_score_pair_3 = user.travel_preference && -(user.travel_preference.vibe_luxurious - user.travel_preference.vibe_curious)
    const vibe_score_pair_4 = user.travel_preference && -(user.travel_preference.vibe_popular - user.travel_preference.vibe_off_the_beaten_path)
    const food_cuisines =  user.travel_preference && user.travel_preference.food_cuisine && user.travel_preference.food_cuisine.concat([null, null, null, null])

    return (
      <Fragment>
        <AppTopBar
          hideMenu={false}
          showBackButton={false}
          onLocationChanged={this.props.onLocationChanged}
          onLocationCleared={this.props.onLocationCleared}
          onCurrencyChange={this.handleReloadResults}
          onChange={this.props.onFilterChange}
          onSigninModalChanged={this.handleSigninChange}
          onSignin={this.props.onSignin}
          user={this.props.user}
          address={startCase(this.props.address)}
          tabSelected={this.props.tabSelected || 'explore'}
          openedSigninDialog={this.state.openedSigninDialog}
          signinDialogType={this.state.openedSigninDialogType !== null && this.state.openedSigninDialogType}
        />

        <div className="destinations explore">
          <div>
            <Paper square className={classes.headlinePaper} style={{marginBottom: -20, paddingBottom: 0, backgroundColor: '#fafafa'}}>
              <h1 className={classes.headline}>
                <Grid container style={{paddingTop: 0, marginLeft: -5, marginTop: 0, marginBottom: 0}}>
                  <Grid item xs={12} sm={12}>
                    <strong className="main-title" style={{fontWeight: 800}}>
                      Recommended
                      <br/>
                    </strong>
                    <small className={classes.subtitle}>Trips based on travel style of</small>
                  </Grid>

                  <Grid item xs={12} sm={12} style={{marginTop: 0}}>
                    <GroupsBar user={this.props.user} onUserUpdated={this.props.onSignin}/>
                  </Grid>
                </Grid>
              </h1>


            </Paper>

            <Grid item xs={12} sm={12} md={12} className={classes.gridSearch}>
              {!this.props.hideSearchBar && <SearchPanel
                center={false}
                hideFieldTo={true}
                // expandable={isWidthDown('xs', this.props.width) ? true : false}
                expandable={false}
                group={this.state.group}
                locationFrom={this.state.from_address}
                search_params={this.state.search_params}
                onSearch={this.handleSearch}
              />}
            </Grid>
          </div>

          <div className="destinations-container" style={{overflow: 'hidden'}}>
          {this.state.destination_groups.length > 0 ?
            <InfiniteScroll
              dataLength={this.state.destination_groups.length} //This is important field to render the next data
              next={this.getDestinations}
              hasMore={this.state.hasMore}
              // hasMore={(this.props.interests || 'all') === 'all' || this.props.interests === 'discover-weekly' || this.props.interests === 'personalized' ? this.state.hasMore : false}
              loader={<div className={classes.buttonLoading}>Loading...</div>}
              style={{display: 'contents'}}
              scrollThreshold={0.4}
            >
              <Grid container spacing={2} className={classes.gridFilters}>
                {((this.state.isLoading && this.state.destination_groups.length === 0) ? Array.from(new Array(1)) : this.state.destination_groups).map((group) => {
                  return <DestinationList key={group ? group.page : 'loading'}
                            group={group && group.key}
                            search_params={this.props.search_params}
                            filters={this.state.filters}
                            next_page_url={group && API + group.next_page_url}
                            destinations={group && group.destinations}
                            title={group && group.title}
                            description={group && group.description}
                            has_next_page={(group && ((this.props.interests || 'all') !== 'all' || this.props.interests === 'discover-weekly' || this.props.interests !== 'personalized') && group.has_next_page)}
                            link_to_all={group && group.link_to_all}
                            page={group && group.page}
                            country={this.props.country}
                            isLoading={this.state.isLoading}
                            onSelected={this.props.onSearch}
                            showHeader={false}
                            showLinkToAll={false}
                            infiniteScroll={false}
                        />
                })}
              </Grid>
            </InfiniteScroll>
            :
            <Grid container spacing={2} className={classes.gridFilters}>
              {((this.state.isLoading && this.state.destination_groups.length === 0) ? Array.from(new Array(1)) : this.state.destination_groups).map((group) => {
                return <DestinationList key={group ? group.key : 'loading'}
                          group={group && group.key}
                          search_params={this.props.search_params}
                          filters={this.state.filters}
                          next_page_url={group && API + group.next_page_url}
                          destinations={group && group.destinations}
                          title={group && group.title}
                          description={group && group.description}
                          has_next_page={(group && ((this.props.interests || 'all') !== 'all' || this.props.interests === 'discover-weekly' || this.props.interests !== 'personalized') && group.has_next_page)}
                          link_to_all={group && group.link_to_all}
                          page={group && group.page}
                          country={this.props.country}
                          isLoading={this.state.isLoading}
                          onSelected={this.props.onSearch}
                          showHeader={false}
                          showLinkToAll={false}
                          infiniteScroll={false}
                      />
              })}
            </Grid>
          }
          </div>
        </div>
      </Fragment>
    )
  }
}

const styles = theme => ({
  h3: {
    fontWeight: 800,
    fontSize: 20,
    margin: '30px 0px 10px 0px',
  },
  headlinePaper: {
    padding: '0px 0px 40px 0px',
    margin: '-100px auto',
    color: '#333',
    // textAlign: 'left',
    width: '100%',
    position: 'relative',
    boxShadow: 'none',
    height: '100%',
    // minHeight: '60vh',
    paddingBottom: '96px',
    backgroundColor: 'transparent',
    // background: 'linear-gradient(180deg, rgb(26 83 53 / 9%) 0%, rgb(205 214 208 / 77%) 100%)',
  },
  headline: {
    maxWidth: 1119,
    // width: '100%',
    display: 'block',
    position: 'relative',
    margin: '0px auto',
    fontSize: 28,
    fontWeight: 400,
    textAlign: 'left',
    marginTop: '30px',
    padding: '120px 20px 50px 20px',

    [theme.breakpoints.down('xs')]: {
      fontSize: 25,
      padding: '99px 20px 40px 20px',
    },
  },
  subtitle: {
    fontWeight: 500,
    fontSize: '50%',
    color: '#828282',
    display: 'block',
    marginTop: 14,
    marginBottom: 5,
  },
  gridFilters: {
    textAlign: 'left',
    maxWidth: 1142,
    margin: '20px auto 0px auto',
    width: 'calc(100% - 0px)',
    overflow: 'hidden',

    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  gridSearch: {
    textAlign: 'left',
    maxWidth: 1130,
    margin: '10px auto -20px auto',
    zIndex: 98,
    position: 'relative',

    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },

    [theme.breakpoints.down('sm')]: {
      margin: '10px 10px -20px 10px',
    },

    [theme.breakpoints.down('xs')]: {
      margin: '10px auto -20px auto',
    },
  },
  buttonBook: {
    // float: 'right',
    color: '#fff',
    margin: '10px 10px 10px 10px',
    backgroundColor: '#02c39a',
    textTransform: 'none',
    // boxShadow: 'none',
    borderRadius: 25,
    fontWeight: 800,
    boxShadow: '0 10px 20px 0 rgb(0 0 0 / 5%)',
    padding: '13px 30px',

    '&:hover': {
      backgroundColor: 'rgb(1, 136, 107)',
      boxShadow: 'none',
    }
  },
  buttonBookOutlined: {
    color: '#02c39a',
    margin: '10px -6px 10px 10px',
    border: '2px solid #02c39a',
    textTransform: 'none',
    borderRadius: 45,
    fontWeight: 800,
    // boxShadow: '0 10px 20px 0 rgb(0 0 0 / 5%)',
    padding: '13px 30px',
    // minWidth: 155,

    '&:hover': {
      border: '2px solid #02c39a',
      boxShadow: 'none',
    }
  },
  buttonLoading: {
    color: '#02c39a',
    textDecoration: 'none',
    margin: '27px auto',
    display: 'block',
    position: 'relative',
    fontSize: '15px',
    fontWeight: 600,
    padding: '13px 20px 13px 27px',
    backgroundColor: 'transparent',
    borderRadius: 50,
    border: '2px solid #02c39a',
    width: 65,
  },
  categoriesContainer: {
    width: '100%',
    margin: '25px auto -30px auto',
    maxWidth: 1092,
    top: 0,
    whiteSpace: 'nowrap',
    overflowX: 'auto',

    [theme.breakpoints.down('sm')]: {
      // margin: '70px auto -20px auto',
      margin: '20px 0px -50px 5px',
    },
  },
  travelStyleContainer: {
    maxWidth: 1119,
    // width: '100%',
    display: 'block',
    position: 'relative',
    margin: '0px auto',
    fontSize: 28,
    fontWeight: 400,
    textAlign: 'left',
    marginTop: '30px',
    padding: '0px 20px',

    [theme.breakpoints.down('xs')]: {
      padding: '40px 10px',
    },
  },
  travelStylePaper: {
    border: '1px solid #e5e5e5',
    padding: '10px',
    marginTop: 30,
    marginBottom: 0,
    backgroundImage: 'url(/discover-weekly-background.svg)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: '0px -4px',

    [theme.breakpoints.down('xs')]: {
      backgroundPosition: '0px -1px',
      margin: '100px auto 0px auto',
    },
  },
  travelStyleIcon: {
    verticalAlign: 'middle',
    float: 'left',
    padding: '14px',
    margin: '0px 20px 0px 10px',
    backgroundColor: '#fff',
    color: '#02c39a',
    borderRadius: 25,
    display: 'block',

    ["@media (max-width:704px)"]: {
      display: 'none !important',
    },

    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  travelStyleTestBtn: {
    margin: '0px 10px 0px 0px !important',
    float: 'right',
    color: '#fff',
    boxShadow: '0 10px 20px 0 rgb(0 0 0 / 5%)',

    [theme.breakpoints.down('xs')]: {
      margin: '10px auto 0px auto !important',
      float: 'left',
    },
  },
})

export default withRouter(withStyles(styles)(UserHome))
